import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type PublicLayoutProps = {
  children: React.ReactNode;
};
const PublicLayout = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="bg-gradient-to-b from-secondary to-primary" data-testid="public-layout">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PublicLayout;